import { render, staticRenderFns } from "./PointsGraph.vue?vue&type=template&id=e727815a&scoped=true"
import script from "./PointsGraph.vue?vue&type=script&lang=js"
export * from "./PointsGraph.vue?vue&type=script&lang=js"
import style0 from "./PointsGraph.vue?vue&type=style&index=0&id=e727815a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e727815a",
  null
  
)

export default component.exports